import styled from "@emotion/styled";
import { Divider, Message } from "semantic-ui-react";
import { BookedSlotTimeIndicator } from "./BookedSlotTimeIndicator";

type Props = {
  occupiedSeats: number;
  startTime: string;
  endTime: string;
};

export const SwaSlotBookedPopup = ({ occupiedSeats, startTime, endTime }: Props) => {
  return (
    <S.Container>
      <Message info size="mini" icon="exclamation circle" content="Test Takers details can be found in ORS Admin" />
      <S.Divider />
      <S.BookedPopupLine>
        <S.CountBadge>{occupiedSeats}</S.CountBadge>
        <S.VerticalDivider />
        <BookedSlotTimeIndicator startTime={startTime} endTime={endTime} />
      </S.BookedPopupLine>
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    min-width: 320px;
  `,
  Divider: styled(Divider)`
    margin: 0.5em 0 !important;
  `,
  BookedPopupLine: styled.div`
    display: flex;
    align-items: center;
    gap: 0.75em;
    font-size: 0.85em;
  `,
  VerticalDivider: styled.div`
    align-self: stretch;
    width: 1px;
    background-color: #d5d8dd;
  `,
  CountBadge: styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    border-radius: 50%;
    background-color: #bf2020;
    color: #fff;
    font-weight: 700;
    font-size: 0.85em;
  `,
};
